import { Box, Stack } from "shared/components/Spor";
import DayPlanTrackings from "features/CenterContent/RoleContent/Personellstyrer/DayPlanTrackings/DayPlanTrackings";
import TrainMap from "features/CenterContent/RoleContent/TrainMap/TrainMap";

export const Personellstyrer = () => (
  <Stack height="100%" overflow="auto">
    <Box flexGrow="1" flexShrink="1">
      <TrainMap />
    </Box>
    <DayPlanTrackings />
  </Stack>
);
